/**
 * Whether a coordinator-supplied schedule link is safe to render as a clickable anchor.
 *
 * The server validates this on the way in and rejects anything that is not an absolute http/https
 * URL, so this is belt and braces — but the value is user-supplied text that the staff queue turns
 * into a link an admin will click, and a client that trusts "the server already checked" is one
 * server regression away from rendering `javascript:`. Callers show a failing value as plain text
 * rather than dropping it, so staff can still see what was submitted.
 *
 * Lives in its own module (not the component file) so exporting it does not trip
 * react-refresh/only-export-components.
 */
export function isSafeScheduleUrl(raw: string | null): boolean {
  if (!raw) return false;
  try {
    const parsed = new URL(raw);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
}
